// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"e81fc908","136":"171c2743","142":"fc71e45d","180":"051023cd","438":"50c97119","538":"3dfd92e9","648":"2e1ba4e3"}[chunkId] + ".chunk.js";
};